import { Eyebrow, SectionHeading } from "../common/Type";
import { RevealStagger, RevealItem } from "../common/Reveal";
import { howItWorks } from "../../lib/content";

export default function HowItWorks() {
  return (
    <section className="relative py-24 md:py-32 bg-kv-bg2/40 border-y border-kv-steel/10" data-testid="section-how-it-works">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-16">
          <Eyebrow className="mb-5">How it works</Eyebrow>
          <SectionHeading>From discovery to a system that evolves.</SectionHeading>
        </div>

        <RevealStagger className="grid grid-cols-1 md:grid-cols-4 gap-5">
          {howItWorks.map((step) => (
            <RevealItem key={step.num} className="kv-card p-8 md:p-9 relative group">
              <div className="flex items-center gap-3 mb-8">
                <span className="h-2 w-2 rounded-full bg-kv-royal kv-node" />
                <span className="h-px w-8 bg-kv-steel/40" aria-hidden />
              </div>
              <h3 className="font-display text-2xl font-medium tracking-tight text-kv-off">{step.title}</h3>
              <p className="mt-4 font-body text-sm md:text-base text-kv-grey leading-relaxed">{step.text}</p>
            </RevealItem>
          ))}
        </RevealStagger>
      </div>
    </section>
  );
}
